<template>
  <div>
    <div class="">
      <!-- <form
        style="width: 90%; margin-left: auto; margin-right: auto;"
        method="POST"
        @submit="createProduct"
      > -->
      <h3 class="header_style">Create New Product</h3>
      <hr class="hr_styling" />
      <el-form
        ref="form"
        :model="form"
        :rules="formRules"
        v-loading="loading"
        element-loading-text="Loading..."
        :element-loading-spinner="svg"
      >
        <el-form-item label="Product Type" prop="producttype">
          <el-input v-model="form.producttype"></el-input>
        </el-form-item>
        <el-form-item label="Product Description" prop="productdescription">
          <el-input v-model="form.productdescription"></el-input>
        </el-form-item>
        <el-form-item label="Battery Specification" prop="battery_spec">
          <el-input
            v-model="form.battery_spec"
            placeholder="5.4 kWh rack mounted lithium batteries"
          ></el-input>
        </el-form-item>
        <el-form-item label="Inverter Specification" prop="inverter_spec">
          <el-input
            v-model="form.inverter_spec"
            placeholder="5 kVA Hybrid Inverter with MPPT Charger Controller"
          ></el-input>
        </el-form-item>
        <el-form-item label="Solar Panel Specification" prop="solar_panel_spec">
          <el-input
            v-model="form.solar_panel_spec"
            placeholder="390W, 72 Cell Monocrystalline modules (Total of 6)"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="Amount OS" prop="amountos">
          <el-input-number v-model="form.amountos" :min="0"></el-input-number>
        </el-form-item> -->
        <el-form-item
          label="Monthly Amount LO (for IPP Systems)"
          prop="monthlyamountlo"
        >
          <el-input v-model="form.monthlyamountlo" type="number"></el-input>
        </el-form-item>
        <el-form-item
          label="Step Value (for IPP Systems: from 1 - 100)"
          prop="step_value"
        >
          <el-input v-model="form.step_value" type="number"></el-input>
        </el-form-item>
        <el-form-item label="Equipment Cost" prop="equipment_cost">
          <el-input v-model="form.equipment_cost" type="number"></el-input>
        </el-form-item>
        <el-form-item label="Maintenance Fee" prop="maintenance_fee">
          <el-input v-model="form.maintenance_fee" type="number"></el-input>
        </el-form-item>
        <el-form-item label="System Type" prop="system_type">
          <el-select
            v-model="form.system_type"
            placeholder="Select System Type"
          >
            <el-option label="5000X" value="5"></el-option>
            <el-option label="5kVA-15kVA" value="15"></el-option>
            <el-option label="20kVA-25kVA" value="20"></el-option>
            <el-option label="30kVA" value="30"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="System Series" prop="system_series">
          <el-select
            v-model="form.system_series"
            placeholder="Select System Series"
          >
            <el-option label="Blue Box Series" value="blue_box"></el-option>
            <el-option label="Opulence Series" value="opulence"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="Installation Cost" prop="installation_cost">
          <el-input-number
            v-model="form.installation_cost"
            :min="0"
          ></el-input-number>
        </el-form-item> -->
        <el-form-item
          label="Annual Interest Rate (%)"
          prop="annual_interest_rate_percent"
        >
          <el-input
            v-model="form.annual_interest_rate_percent"
            type="number"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item
          label="Monthly Payment Period"
          prop="monthly_payment_period"
        >
          <el-input-number
            v-model="form.monthly_payment_period"
            :min="0"
          ></el-input-number>
        </el-form-item> -->
        <el-form-item label="Tenure LO" prop="tenurelo">
          <el-input-number v-model="form.tenurelo" :min="0"></el-input-number>
        </el-form-item>
        <el-form-item label="Upload Image" prop="image_url">
          <a-upload
            :action="uploadUrl"
            @change="handleChange"
            @drop="handleDrop"
            accept="image/*"
          >
            <a-button> <a-icon type="upload" /> Click to Upload Image</a-button>
          </a-upload>
          <!-- <el-input v-model="form.image_url"></el-input> -->
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm"
            ><a-spin :spinning="spinnings" size="small" /> Submit</el-button
          >
        </el-form-item>
      </el-form>
      <!-- <div class="">
          <div class="form-group row">
            <label class="col-lg-4 col-form-label" for="productName"
              >Product Name</label
            >
            <div class="col-lg-8">
              <input
                type="text"
                class="form-control form-control-lg"
                id="productName"
                v-model="regParams.producttype"
                placeholder="Product's name"
                required
              />
            </div>
          </div>

          <div class="form-group row">
            <label class="col-lg-4 col-form-label" for="productDescription"
              >Product Description</label
            >
            <div class="col-lg-8">
              <input
                type="text"
                class="form-control form-control-lg"
                id="productDescription"
                v-model="regParams.productdescription"
                placeholder="Product Description"
                required
              />
            </div>
          </div>

          <div class="form-group row">
            <label class="col-lg-4 col-form-label" for="amountOs"
              >OS Amount</label
            >
            <div class="col-lg-8">
              <input
                type="number"
                class="form-control form-control-lg"
                id="amountOs"
                v-model="regParams.amountos"
                placeholder="OS Amount"
                required
              />
            </div>
          </div>

          <div class="form-group row">
            <label class="col-lg-4 col-form-label" for="monthlyAmountLo"
              >LO Amount</label
            >
            <div class="col-lg-8">
              <input
                type="number"
                class="form-control form-control-lg"
                id="monthlyAmountLo"
                v-model="regParams.monthlyamountlo"
                placeholder="LO Amount"
                required
              />
            </div>
          </div>

          <div class="form-group row">
            <label class="col-lg-4 col-form-label" for="tenureLo"
              >LO Tenure</label
            >
            <div class="col-lg-8">
              <input
                type="number"
                class="form-control form-control-lg"
                id="tenureLo"
                v-model="regParams.tenurelo"
                placeholder="Tenure LO"
                required
              />
            </div>
          </div>

          <div class="form-group row">
            <label class="col-lg-4 col-form-label" for="image_url"
              >Image URL</label
            >
            <div class="col-lg-8">
              <input
                type="text"
                class="form-control form-control-lg"
                id="image_url"
                v-model="regParams.image_url"
                placeholder="Image URL"
                required
              />
            </div>
          </div>

          <div>
            <button
              type="submit"
              class="btn btn-info btn-block btn-lg"
              @click="createProduct"
            >
              Create Product
            </button>
          </div>
        </div> -->
      <!-- </form> -->
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { isEmpty } from "element-ui/src/utils/util";
import { Form, FormItem } from "element-ui";
import { ONBOARDING_URL } from "@/utils/http-common.js";

export default {
  name: "SetupArnergyProduct",
  components: {
    "el-form": Form,
    "el-form-item": FormItem
  },
  data() {
    return {
      uploadUrl: `${ONBOARDING_URL}/kycfiles/s3-file-upload`,
      loading: false,
      spinnings: false,
      form: {
        producttype: "",
        productdescription: "",
        system_type: "",
        system_series: "",
        battery_spec: "",
        inverter_spec: "",
        solar_panel_spec: "",
        amountos: null,
        monthlyamountlo: null,
        equipment_cost: 0.0,
        step_value: 10,
        maintenance_fee: 0.0,
        installation_cost: 0.0,
        annual_interest_rate_percent: 1.0,
        monthly_payment_period: 1,
        tenurelo: null,
        image_url: ""
      },
      formRules: {
        producttype: [
          {
            required: true,
            message: "Product Type is required",
            trigger: "blur"
          }
        ],
        solar_panel_spec: [
          {
            required: true,
            message: "Solar Panel Specification is required",
            trigger: "blur"
          }
        ],
        inverter_spec: [
          {
            required: true,
            message: "Inverter Specification is required",
            trigger: "blur"
          }
        ],
        battery_spec: [
          {
            required: true,
            message: "Battery Specification is required",
            trigger: "blur"
          }
        ],
        system_type: [
          {
            required: true,
            message: "System Type is required",
            trigger: "blur"
          }
        ],
        system_series: [
          {
            required: true,
            message: "System Series is required",
            trigger: "blur"
          }
        ],
        productdescription: [
          {
            required: true,
            message: "Product Description is required",
            trigger: "blur"
          }
        ],
        amountos: [
          { required: true, message: "Amount OS is required", trigger: "blur" }
        ],
        monthlyamountlo: [
          {
            required: true,
            message: "Monthly Amount LO is required",
            trigger: "blur"
          }
        ],
        equipment_cost: [
          {
            required: true,
            message: "Equipment Cost is required",
            trigger: "blur"
          }
        ],
        maintenance_fee: [
          {
            required: true,
            message: "Maintenance Fee is required",
            trigger: "blur"
          }
        ],
        installation_cost: [
          {
            required: true,
            message: "Installation Cost os required",
            trigger: "blur"
          }
        ],
        annual_interest_rate_percent: [
          {
            required: true,
            message: "Annual Interest Rate is required",
            trigger: "blur"
          }
        ],
        monthly_payment_period: [
          {
            required: true,
            message: "Monthly Payment Period s required",
            trigger: "blur"
          }
        ],
        tenurelo: [
          {
            required: true,
            message: "Tenure LO is required",
            trigger: "blur"
          }
        ]
        // image_url: [
        //   {
        //     required: true,
        //     message: "Image upload is required",
        //     trigger: "click"
        //   },
        //   {
        //     type: "button",
        //     message: "Please Upload an Image",
        //     trigger: "click"
        //   }
        // ]
        // Add more validation rules for other properties as needed
      },
      regParams: {
        producttype: "",
        productdescription: "",
        amountos: "",
        monthlyamountlo: "",
        step_value: "",
        tenurelo: "",
        image_url: ""
      },
      errorsResult: {}
    };
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  methods: {
    handleChange(info) {
      const status = info.file.status;
      if (status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (status === "done") {
        this.form.image_url = info.file.response.url;
        console.log("this.form.image_url", this.form.image_url);
        message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
    handleDrop(e) {
      console.log(e);
    },
    submitForm() {
      // @todo: add loading state
      this.$refs.form.validate(valid => {
        if (valid) {
          const HTTP = this.$httpUtils.FASTHTTP;
          const url = "/product/create-products";
          this.loading = true;
          this.spinnings = true;
          HTTP.post(url, this.form)
            .then(res => {
              console.log("response", res);
              this.showSuccessMsg({ message: "Device setup successfully!" });
              this.loading = false;
              this.spinnings = false;
              location.reload();
            })
            .catch(error => {
              console.log("setup error", error.response);
              this.loading = false;
              this.spinnings = false;
              this.showErrorMsg({ message: error.response.data.error.message });
            });
        } else {
          // Form validation failed
        }
      });
    },
    // validateReg() {
    //   var errors = [];
    //   for (let [field, value] of Object.entries(this.regParams)) {
    //     value = value + "";
    //     if (value !== "null" && value !== Number.isInteger(value)) {
    //       value = value.trim();
    //     }
    //     switch (field) {
    //       case "producttype":
    //         if (value === "null" || value === "NaN" || isEmpty(value)) {
    //           errors[field] = "Product Name cannot be empty.";
    //         }
    //         break;
    //       case "productdescription":
    //         if (value === "null" || value === "NaN" || isEmpty(value)) {
    //           errors[field] = "Product Description cannot be empty.";
    //         }
    //         break;
    //       case "amountos":
    //         if (value === "null" || value === "NaN" || isEmpty(value)) {
    //           errors[field] = "OS Amount cannot be empty.";
    //         }
    //         break;
    //       case "monthlyamountlo":
    //         if (value === "null" || value === "NaN" || isEmpty(value)) {
    //           errors[field] = "LO Monthly amount cannot be empty.";
    //         }
    //         break;
    //       case "tenurelo":
    //         if (value === "null" || value === "NaN" || isEmpty(value)) {
    //           errors[field] = "LO Tenure cannot be empty.";
    //         }
    //         break;
    //       case "image_url":
    //         if (value === "null" || value === "NaN" || isEmpty(value)) {
    //           errors[field] = "Image URL cannot be empty.";
    //         }
    //         break;
    //       default:
    //         break;
    //     }
    //   }
    //   this.errorsResult = errors;
    // },
    createProduct(e) {
      e.preventDefault();
      this.validateReg();
      var errorLength = Object.keys(this.errorsResult).length;
      if (errorLength > 0) {
        this.errorMessage = "Fill All FIelds!!!";
        this.displayError = true;
        setTimeout(() => {
          this.displayError = false;
        }, 3000);
        var errorMsg = Object.values(this.errorsResult).join("<br>");
        this.showErrorMsg({
          message: errorMsg
        });

        return;
      }

      const HTTP = this.$httpUtils.FASTHTTP;
      const url = "/product/create-products";
      HTTP.post(url, this.regParams)
        .then(res => {
          console.log("response", res);
          this.showSuccessMsg({ message: "Device setup successfully!" });
          location.reload();
        })
        .catch(error => {
          console.log("setup error", error.response);
          this.showErrorMsg({ message: error.response.data.error.message });
        });
    }
  },
  mounted() {},
  created() {}
};
</script>

<style scoped>
h3.header_style {
  font-weight: 600;
  font-size: 24px;
  text-align: left;
}
.row {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/onboarding/AdminOnboarding/SetupArnergyProduct.vue